module.exports = __webpack_public_path__ + "static/72046f5f247736e34657caf76a94a1b6.svg";